import sw from '@uswitch/ev-utils/switch'

/**
 * Enum of button variants
 * @enum {string}
 */
export const SortButtonVariants = { DESCENDING: 'desc', ASCENDING: 'asc', INACTIVE: 'in' }

export const SortButton = ({ variant = SortButtonVariants.INACTIVE, ...props }) => {
  const descendingPath = 'M10.6667 11.34V6.66667H9.33337V11.34H7.33337L10 14L12.6667 11.34H10.6667Z'
  const ascendingPath = 'M6.00004 2L3.33337 4.66H5.33337V9.33333H6.66671V4.66H8.66671L6.00004 2Z'
  return (
    <svg
      sx={{
        display: 'inline-block',
        position: 'relative',
        bottom: '-2px',
        width: '16px',
        height: '16px',
      }}
      {...props}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill='currentColor'
        d={sw({
          [SortButtonVariants.ASCENDING]: ascendingPath,
          [SortButtonVariants.DESCENDING]: descendingPath,
          default: descendingPath + ascendingPath,
        })(variant)}
      />
    </svg>
  )
}
